[
  { "date": "2023-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2023-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2024-01-01", "holidayName": "Nowy Rok" },
  { "date": "2024-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2024-03-31", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2024-04-01", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2024-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2024-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2024-05-19", "holidayName": "Zielone Świątki" },
  { "date": "2024-05-30", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2024-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2024-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2024-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2024-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2024-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2025-01-01", "holidayName": "Nowy Rok" },
  { "date": "2025-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2025-04-20", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2025-04-21", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2025-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2025-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2025-06-08", "holidayName": "Zielone Świątki" },
  { "date": "2025-06-19", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2025-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2025-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2025-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2025-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2025-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2026-01-01", "holidayName": "Nowy Rok" },
  { "date": "2026-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2026-04-05", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2026-04-06", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2026-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2026-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2026-05-24", "holidayName": "Zielone Świątki" },
  { "date": "2026-06-04", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2026-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2026-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2026-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2026-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2026-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2027-01-01", "holidayName": "Nowy Rok" },
  { "date": "2027-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2027-03-28", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2027-03-29", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2027-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2027-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2027-05-16", "holidayName": "Zielone Świątki" },
  { "date": "2027-05-27", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2027-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2027-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2027-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2027-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2027-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2028-01-01", "holidayName": "Nowy Rok" },
  { "date": "2028-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2028-04-16", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2028-04-17", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2028-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2028-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2028-06-04", "holidayName": "Zielone Świątki" },
  { "date": "2028-06-15", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2028-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2028-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2028-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2028-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2028-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2029-01-01", "holidayName": "Nowy Rok" },
  { "date": "2029-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2029-04-01", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2029-04-02", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2029-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2029-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2029-05-20", "holidayName": "Zielone Świątki" },
  { "date": "2029-05-31", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2029-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2029-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2029-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2029-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2029-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2030-01-01", "holidayName": "Nowy Rok" },
  { "date": "2030-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2030-04-21", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2030-04-22", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2030-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2030-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2030-06-09", "holidayName": "Zielone Świątki" },
  { "date": "2030-06-20", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2030-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2030-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2030-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2030-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2030-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2031-01-01", "holidayName": "Nowy Rok" },
  { "date": "2031-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2031-04-13", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2031-04-14", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2031-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2031-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2031-06-01", "holidayName": "Zielone Świątki" },
  { "date": "2031-06-12", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2031-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2031-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2031-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2031-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2031-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2032-01-01", "holidayName": "Nowy Rok" },
  { "date": "2032-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2032-03-28", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2032-03-29", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2032-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2032-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2032-05-16", "holidayName": "Zielone Świątki" },
  { "date": "2032-05-27", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2032-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2032-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2032-11-11", "holidayName": "Narodowe Święto Niepodległości" },
  { "date": "2032-12-25", "holidayName": "Boże Narodzenie (pierwszy dzień)" },
  { "date": "2032-12-26", "holidayName": "Boże Narodzenie (drugi dzień)" },
  { "date": "2033-01-01", "holidayName": "Nowy Rok" },
  { "date": "2033-01-06", "holidayName": "Święto Trzech Króli" },
  { "date": "2033-04-17", "holidayName": "Niedziela Wielkanocna" },
  { "date": "2033-04-18", "holidayName": "Poniedziałek Wielkanocny" },
  { "date": "2033-05-01", "holidayName": "Święto Państwowe" },
  { "date": "2033-05-03", "holidayName": "Święto Narodowe Trzeciego Maja" },
  { "date": "2033-06-05", "holidayName": "Zielone Świątki" },
  { "date": "2033-06-16", "holidayName": "Dzień Bożego Ciała" },
  {
    "date": "2033-08-15",
    "holidayName": "Wniebowzięcie Najświętszej Marii Panny"
  },
  { "date": "2033-11-01", "holidayName": "Uroczystość Wszystkich świętych" },
  { "date": "2033-11-11", "holidayName": "Narodowe Święto Niepodległości" }
]
